import "./IconLOSGroup.scss";
import { ReactComponent as LOSGroupIcon } from "./svg/losGroup.svg";

interface Props {
  className?: string;
}

export const IconLOSGroup = ({ className = "" }: Props) => {
  return (
    <span className={`IconLOSGroup ${className}`}>
      <LOSGroupIcon />
    </span>
  );
};
